// 工具类
import moment from 'moment'
import 'moment/locale/zh-cn'
import * as constants from '@/util/constants'
// import CryptoJS from 'crypto-js'

/**
 * 生成随机字符串
 */
export function guid () {
  function s4 () {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  // s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
  let timestamp = moment(new Date()).format('YYYYMMDDHHmmss')
  return timestamp + s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4()
}

export function uuid () {
  let uuid = localStorage.getItem('uuid')
  if (uuid) {
    return uuid
  } else {
    uuid = guid()
    localStorage.setItem('uuid', uuid)
  }
  return uuid
}

export function formatClient (client) {
  // console.log('client: ', client)
  if (client === null) {
    return ''
  }
  if (client === constants.CLIENT_WEB) {
    return '电脑网站'
  } else if (client === constants.CLIENT_WAP) {
    return '手机网站'
  } else if (client.includes(constants.CLIENT_ANDROID)) {
    return '安卓App'
  } else if (client.includes(constants.CLIENT_IOS)) {
    return '苹果App'
  } else if (client === constants.CLIENT_WECHAT_MP) {
    return '公众号'
  } else if (client === constants.CLIENT_WECHAT_MINI) {
    return '小程序'
  }
}

export function currentTimestamp () {
  return moment().format('YYYY-MM-DD HH:mm:ss')
  // return '2989-01-01 00:12:12'
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

export function timeAgo (time) {
  var currentTime = new Date().getTime()
  var between = currentTime - time
  var days = Math.floor(between / (24 * 3600 * 1000))
  if (days === 0) {
    var leave1 = between % (24 * 3600 * 1000)
    var hours = Math.floor(leave1 / (3600 * 1000))
    if (hours === 0) {
      var leave2 = leave1 % (3600 * 1000)
      var minutes = Math.floor(leave2 / (60 * 1000))
      if (minutes === 0) {
        var leave3 = leave2 % (60 * 1000)
        var seconds = Math.round(leave3 / 1000)
        return seconds + ' 秒前'
      }
      return minutes + ' 分钟前'
    }
    return hours + ' 小时前'
  }
  if (days < 0) return '刚刚'
  if (days < 5) {
    return days + ' 天前'
  } else {
    return moment(time).format('YYYY-MM-DD HH:mm')
  }
}

export function isObject (value) {
  return value && typeof value === 'object' && value.constructor === Object
}

// // let aesKey = new Uint8Array(aesjs.utils.utf8.toBytes('16BytesLengthKey'))
// // let aesIv = new Uint8Array(aesjs.utils.utf8.toBytes('A-16-Byte-String'))
// var aesKey = CryptoJS.enc.Utf8.parse('16BytesLengthKey') // 密钥
// var aesIv = CryptoJS.enc.Utf8.parse('A-16-Byte-String') // 初始向量，不设置会随机生成(当然也就无法解密了)

// // github.com/brix/crypto-js
// // https: // https://xiaopc.org/2016/07/26/crypto-js-%E4%BB%8B%E7%BB%8D%E4%BB%A5%E5%8F%8A%E4%B8%80%E4%B8%AA%E5%B8%B8%E8%A7%81%E7%9A%84%E5%9D%91/
// export function encrypt (content) {
//   //
//   var encrypted = CryptoJS.AES.encrypt(content, aesKey, {
//     iv: aesIv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7
//   })
//   //
//   return encrypted.toString()
// }

// // https://xiaopc.org/2016/07/26/crypto-js-%E4%BB%8B%E7%BB%8D%E4%BB%A5%E5%8F%8A%E4%B8%80%E4%B8%AA%E5%B8%B8%E8%A7%81%E7%9A%84%E5%9D%91/
// export function decrypt (content) {
//   var decrypted = CryptoJS.AES.decrypt(content, aesKey, {
//     iv: aesIv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7
//   })
//   // console.log('decrypt', decrypted)
//   // 转换为 utf8 字符串
//   return CryptoJS.enc.Utf8.stringify(decrypted)
// }
